import { getAllPorts, getCountryPorts } from "@/api/dictionaryAPI";
import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import { map } from "lodash";

export const fetchAllPorts = createAsyncThunk("ports/fetchAllPorts", async (reqObj) => {
    console.log("fetchAllPorts === ", reqObj.offset, reqObj.limit, reqObj.search_txt, reqObj.type);
    const response = await getAllPorts(reqObj.offset, reqObj.limit, reqObj.search_txt);
    return { type: reqObj.type, response: response };
});

export const fetchCountryPorts = createAsyncThunk("ports/fetchCountryPorts", async (reqObj) => {
    console.log("CountryID ============ ", reqObj);
    let response = await getCountryPorts(reqObj.countryID);
    return { type: reqObj.type, response: response };
});

const portSlice = createSlice({
    name: "ports",
    initialState: { list: [], loading: false, error: null, originPorts: [], destinationPorts: [] },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllPorts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllPorts.fulfilled, (state, action) => {
                console.log("action **************** ", action);
                if (action.payload.type === "origin_port") {
                    state.loading = false;
                    state.originPorts = action.payload.response;
                }
                if (action.payload.type === "destination_port") {
                    state.loading = false;
                    state.destinationPorts = action.payload.response;
                }

                //state.list = action.payload
            })
            .addCase(fetchAllPorts.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            });

        builder
            .addCase(fetchCountryPorts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountryPorts.fulfilled, (state, action) => {
                console.log("action ================ ", action);
                if (action.payload.type === "origin_country") {
                    state.loading = false;
                    state.originPorts = action.payload.response;
                }
                if (action.payload.type === "destination_country") {
                    state.loading = false;
                    state.destinationPorts = action.payload.response;
                }

            })
            .addCase(fetchCountryPorts.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })
    }
});

export const selectPorts = (state) => state.ports.list;

export const selectOriginCountryPorts = (state) => state.ports.originPorts;
export const selectDestinationCountryPorts = (state) => state.ports.destinationPorts;

export const selectFormattedPorts = createSelector([selectPorts], (ports) => map(ports, (port, k) => {
    return {
        value: port.id,
        label: port.name,
    }
}));

export const selectFormattedOriginCountryPorts = createSelector([selectOriginCountryPorts], (ports) => map(ports, (port, k) => {
    return {
        value: port.id,
        label: port.name,
    }
}));

export const selectFormattedDestinationCountryPorts = createSelector([selectDestinationCountryPorts], (ports) => map(ports, (port, k) => {
    return {
        value: port.id,
        label: port.name,
    }
}));

export default portSlice.reducer;
